export default {
    methods: {
        renderDate(date) {
            return this.$moment(date).format('YYYY-MM-DD')
        },
        renderTime(date) {
            return this.$moment(date).format('HH:mm')
        },
        renderDateTime(date) {
            return this.$moment(date).format('YYYY-MM-DD HH:mm')
        }
    }
};
